import { render, staticRenderFns } from "./InvalidModal.vue?vue&type=template&id=90e2452e&scoped=true"
import script from "./InvalidModal.vue?vue&type=script&lang=js"
export * from "./InvalidModal.vue?vue&type=script&lang=js"
import style0 from "./InvalidModal.vue?vue&type=style&index=0&id=90e2452e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e2452e",
  null
  
)

export default component.exports